import ShopifyObject from './ShopifyObject';

export default class CollectionImage extends ShopifyObject {
  /**
   * @param {ShopifyCollectionImage} image
   */
  constructor(image) {
    super(image.id);
    this._createdAt = image.created_at || new Date(0);
    this._src = image.src || '';
    this._alt = image.alt || null;
  }

  /**
   * @returns {Date}
   */
  get createdAt() {
    return this._createdAt;
  }

  /**
   * @returns {string}
   */
  get src() {
    return this._src;
  }

  /**
   * @returns {string}
   */
  get alt() {
    return this._alt;
  }

  /**
   *
   * @return {Object} - Shopify Collection Image Object.
   */
  JSON() {
    return {
      alt: this.alt,
      created_at: this.createdAt,
      id: super.id,
      src: this.src,
    };
  }
}
